const config = [
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '基本信息',
        },
    },
    {
        component: 'ZlmNormalDetail',
        options: {
            data: {},
        },
    },
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '中标候选人',
        },
    },
    {
        component: 'ZlmTabDetail',
        options: {
            title: '候选人',
            data: [],
        },
    },
]

const { getProjectTypeName } = require('../projectType')
const { getPurchaseTypeName } = require('../purchaseType')
const { getZhongBiaoTypeName } = require('../zhongBiaoType')

const mixin = {
    data() {
        return {
            config: JSON.parse(JSON.stringify(config)),
        }
    },
    methods: {
        getData() {
            this.$request.post(`/transformToAfter/gt-jy-jianguan/api/zbhxrgs/zbInfoView.do`, {
                bdGuid: this.form.bdGuid,
            }, { showLoading: true }).then((res) => {
                this.config[1].options.data = {
                    '标段/包名称': res.data.rows.bdName,
                    '标段/包编号': res.data.rows.bdBH,
                    '项目类型': getProjectTypeName(res.data.rows.zbxmlx),
                    '采购方式': getPurchaseTypeName(res.data.rows.cgFangShi),
                    '中标形式': getZhongBiaoTypeName(res.data.rows.zbXingShi),
                    '评标时间': this.$util.timeFormatter(res.data.rows.pbTime),
                    // '预算价': res.data.rows.bdHeTongGuJiaDisp + '元',
                }
                if (res.data && res.data.rows.zbhxrList) {
                    this.config[3].options.data = res.data.rows.zbhxrList.map((t) => ({
                            '中标候选人': t.tbrName,
                            '中标金额(元)': t.zhongBiaoJia,
                            '质量': t.wjzhiLiang,
                            '工期（天）': t.wjgongQi,
                            '项目负责人': t.fuZeRen,
                            '负责人证书': t.fzrZhengShu,
                            '资格能力条件': t.ziGeNengLi,
                            '其他说明': t.heGeNeiRong,
                        }))
                }
            })
        },
        pass() {
            this.commit()
        },
        fail(opinion) {
            this.commit({
                opValue: '2', // 不通过
                opinion: opinion,
            })
        },
    },
}

module.exports = {
    config,
    mixin,
}
